var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-indicators"},_vm._l((_vm.count),function(item,index){return _c('button',{key:index,staticClass:"carousel-indicator-item",class:{ active: _vm.active === index },attrs:{"id":_vm.key},on:{"click":function($event){return _vm.scroll(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }